// If target includes search param "scroll-to" or "click",
// use param values as query selectors and scroll or click them
// Will not work with param values with "#" in it, because browser handle hash strings on their own (use %23 instead)

export function handleScrollAndClick (event: Event, anchorTarget: string) {
    if (!anchorTarget?.includes('?')) return

    const url = new URL(anchorTarget, window.location.origin)
    const { searchParams } = url

    const scrollTo = searchParams.get('scroll-to')
    const click = searchParams.get('click')

    if (!scrollTo && !click) return

    event.preventDefault()

    if (scrollTo) document.querySelector(scrollTo)?.scrollIntoView()
    if (click) (document.querySelector(click) as HTMLElement | null)?.click()
}
